module.exports = __webpack_public_path__ + "static/9-fe346e937cb546067e2abeb2449f9663.png";